import type { ModalErrorReporter } from '../../errors';
import type { ModalStackStore } from '../../stack';
import type { ModalHostApi } from './modalHost';
import type { ModalInstanceRegistry } from './modalInstanceRegistry';

export interface ModalHostInternals {
  stackStore: ModalStackStore;
  instances: ModalInstanceRegistry;
  unresolvedTimeoutMs: number;
  reportError: ModalErrorReporter;
  discardModal: (id: string) => void;
}

const internalsByHost = new WeakMap<ModalHostApi, ModalHostInternals>();

export const setModalHostInternals = (host: ModalHostApi, internals: ModalHostInternals) => {
  internalsByHost.set(host, internals);
};

export const getModalHostInternals = (host: ModalHostApi) => {
  const internals = internalsByHost.get(host);

  if (!internals) throw new Error('Modal host must be created by createModalHost.');

  return internals;
};
